export const Steps = {
  profile: 'profile-tab',
  orders: 'myOrder-tab',
  payment: 'payment-tab',
  account: 'account-tab',
};
